var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// /usr/src/app/node_modules/core-js/modules/_cof.js
// module id = ../../../../core-js/modules/_cof.js
// module chunks = polyfills